"use strict";
Object.defineProperty(exports, "__esModule", {
    value: true
});
Object.defineProperty(exports, "default", {
    enumerable: true,
    get: function() {
        return Workspace;
    }
});
let Workspace = class Workspace {
    static async getByTitle(..._args) {
        return undefined;
    }
    static async get(..._args) {
        return null;
    }
    static async insert(..._args) {
        return null;
    }
    static async update(..._args) {
        return null;
    }
    static async updateStatusAndPlan(..._args) {
        return null;
    }
    static async delete(..._args) {}
    static async softDelete(..._args) {
        return false;
    }
    static async list(..._args) {
        return [];
    }
    static async count(..._args) {
        return 0;
    }
    static async listByOrgId(..._args) {
        return [];
    }
    static async updateOrgId(..._args) {
        return null;
    }
    static async getFirstWorkspace(..._args) {
        return null;
    }
    static async getResourceStats(..._args) {
        return {};
    }
    static async getStorageStats(..._args) {
        return null;
    }
    static async clearWorkspaceStatsCache(..._args) {}
    constructor(workspace){
        Object.assign(this, workspace);
    }
};
